export enum treasuryWithdrawFormFields {
  amount = 'amount',
  beneficiaryName = 'beneficiaryName',
  beneficiaryIban = 'beneficiaryIban',
  beneficiarySwiftCode = 'beneficiarySwiftCode',
  reason = 'reason',
}
